<template>
  <!-- 练习中心考试练习模式 -->
  <div class="uni-startPractice">
    <div class="leftBox">
      <Title text="我的收藏">
        <i
          slot="right"
          class="iconfont iconfanhui icon-back"
          @click="$router.push({ name: 'myCollect' })"
        ></i>
      </Title>
      <ul>
        <li class="mat10" v-for="item in datas" :key="item.id">
          <div v-if="item.question_style !== 6">
            <el-collapse v-model="activeNames">
              <el-collapse-item
                class="question-collapse-item"
                :name="item.question_id"
              >
                <template slot="title">
                  <span class="primary mar10" style="align-self: flex-start"
                    >[{{ item.question_title }}]</span
                  >
                  <span style="flex: 1">{{
                    textLength(item.title, item.id)
                  }}</span>
                  <!--                  <span class="gray-light mal10 mar10"-->
                  <!--                    >（来自-->
                  <!--                    <span v-if="item.make_type === 3">试卷练习</span>-->
                  <!--                    <span v-if="item.make_type === 2">章节练习</span>-->
                  <!--                    <span v-if="item.make_type === 1">做作业</span>-->
                  <!--                    <span v-if="item.make_type === 4">智能练习</span>-->
                  <!--                    ）-->
                  <!--                  </span>-->
                </template>
                <!-- 填空题 -->
                <FillBlank
                  v-if="item.question_style === 4"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 单选题 -->
                <ChoiceOne
                  v-if="item.question_style === 1"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 多选题 -->
                <ChoiceMultiple
                  v-if="item.question_style === 3"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 判断题 -->
                <Judge
                  v-if="item.question_style === 2"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 简答题 -->
                <Subjective
                  v-if="item.question_style === 5"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <div class="submit mat20">
                  <div @click="cancelCollect(item.question_id)">
                    {{ item.is_collect ? "取消收藏" : "收藏" }}
                  </div>
                </div>

                <!-- 解析 -->
                <QuestionAnalysis
                  :analysisDatas="item"
                  :showNotes="true"
                  :isCollect="{ is_true: true }"
                />
              </el-collapse-item>
            </el-collapse>
          </div>
        </li>
      </ul>
      <ComponentEmpty v-if="datas.length == 0" title="暂无收藏" tips="" />
    </div>
  </div>
</template>

<script>
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import QuestionAnalysis from "./questionAnalysis";
import { getCollectTopic, delCollect, saveCollect } from "@/api/basic";

export default {
  name: "uni-startPractice",
  components: {
    QuestionAnalysis, //解析
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答
  },
  data() {
    return {
      courseUuid: this.$route.query.courseUuid,
      topicType: this.$route.query.topicType,
      activeNames: [],
      isDisabled: true,
      // 题目集合
      datas: [],
      page: 1,
      limit: 10,
    };
  },
  created() {
    this.getAnalysisDetail();
  },
  methods: {
    /**
     * 收藏题目
     */
    async getAnalysisDetail() {
      const params = {
        question_style: this.topicType,
        course_id: this.courseUuid,
        page: this.page,
        limit: this.limit,
      };
      const res = await getCollectTopic(params);
      if (res.code == 200) {
        this.datas = res.result.list || [];
        console.log(this.datas);
      }
    },
    textLength(val, id) {
      if (this.activeNames.includes(id)) {
        return val;
      } else {
        if (val.length > 100) return val.substr(0, 100) + "...";
        return val;
      }
    },
    /**
     * 取消收藏
     */
    async cancelCollect(topicId) {
      const params = {
        question_id: topicId,
      };
      const res = await delCollect(params);
      if (res) {
        await this.getAnalysisDetail();
        const lists = this.datas;
        this.datas = lists.map((item) => {
          if (item.id == topicId) {
            item.is_collect = false;
          }
          return item;
        });
      }
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.uni-startPractice {
  display: flex;
  min-height: $contentH;

  /deep/ .question-collapse-item {
    .el-collapse-item__header {
      background-color: #f8f8f8;
      padding: 20px;
      height: auto;
      line-height: normal;
    }
  }

  .leftBox {
    background-color: #ffffff;
    flex: 1 1 auto;
    padding: 20px 40px;
    margin: 20px;
    margin-bottom: 0;

    .icon-back {
      font-size: 34px;
      color: #a8a8a8;
      cursor: pointer;

      &:hover {
        color: #333;
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
</style>
